import React from 'react';
import { Image, ImageModifier } from '../Image';
import { ProfileImageSmall } from '../../../types/api/ImageType';
import { Modifier } from '../../../lib/bemUtils/Modifier';
import bem from '../../../lib/bemUtils/bem';

type PersonProfileImageSmallProps = {
  profileImageUrl: ProfileImageSmall;
  profileName?: string;
  emptyAltText?: boolean;
  modifier?: Modifier<'personal'>;
};

/**
 * Displays a user image if a profilePic is supplied. If not placeholder image should be returned.
 */
export function PersonProfileImageSmall({
  profileImageUrl,
  profileName,
  emptyAltText,
  modifier,
}: PersonProfileImageSmallProps) {
  return (
    <span className="person-profile-image-small">
      <span className={bem('person-profile-image-small__container', modifier)}>
        <span className="person-profile-image-small__pic">
          <Image
            image={profileImageUrl}
            customAltText={profileName}
            emptyAltText={emptyAltText}
            modifier={ImageModifier.WIDTH_HEIGHT_100}
            lazyLoading
          />
        </span>
      </span>
    </span>
  );
}
